import { render, staticRenderFns } from "./dialogSettingAccess.vue?vue&type=template&id=b9ecf3ce&scoped=true&lang=pug&"
import script from "./dialogSettingAccess.vue?vue&type=script&lang=js&"
export * from "./dialogSettingAccess.vue?vue&type=script&lang=js&"
import style0 from "./dialogSettingAccess.vue?vue&type=style&index=0&id=b9ecf3ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ecf3ce",
  null
  
)

export default component.exports